import { validateField } from 'utils/validate.util'
import { z } from 'zod'

export const prosecutorSchema = z.object({
  nome: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  cargo: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  matricula: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
})

export type ProsecutorType = z.infer<typeof prosecutorSchema>

export const prosecutorInit: ProsecutorType = {
  nome: '',
  cargo: '',
  matricula: '',
}
